import Vue from 'vue';
import Vuex from 'vuex';
import poAutomationDashboard from './modules/po-automation-dashboard';
import unapprovedPOs from './modules/unapproved-pos';
import menuVersion from './modules/menu-version';
import poDashboard from './modules/poDashboard';
import aiChat from './modules/aiChat';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    poAutomationDashboard,
    unapprovedPOs,
    menuVersion,
    poDashboard,
    aiChat,
  },
});
